export const MODULE_LIST_SET = "MODULE_LIST_SET";
export const CURRENT_MODULE_SET = "CURRENT_MODULE_SET";
export const CURRENT_LESSON_SET = "CURRENT_LESSON_SET";
export const USER_ADDRESS = "USER_ADDRESS";
export const USER_WATCHED_VIDEO = "USER_WATCHED_VIDEO";
export const SET_PROCESSING = "SET_PROCESSING";
